import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AthletePayload {
  full_name: string;
  fight_name?: string | null;
  birth_date?: string | null;
  gender?: 'M' | 'F' | null;
  weight_category?: string | null;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  is_rookie?: boolean;
  victories?: number;
  defeats?: number;
  draws?: number;
  tapology_link?: string | null;
  sherdog_link?: string | null;
  instagram?: string | null;
  phone?: string | null;
  email?: string | null;
}

@Injectable({ providedIn: 'root' })
export class AthleteService {
  constructor(private http: HttpClient) {}

  search(params: Record<string, any>): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params || {}).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        httpParams = httpParams.set(key, params[key]);
      }
    });

    return this.http.get(`${environment.apiUrl}/athletes`, { params: httpParams });
  }

  create(payload: AthletePayload): Observable<any> {
    return this.http.post(`${environment.apiUrl}/athletes`, payload);
  }

  update(id: number, payload: Partial<AthletePayload>, isSelfUpdate: boolean = false): Observable<any> {
    const url = isSelfUpdate 
      ? `${environment.apiUrl}/athletes/${id}/self-update`
      : `${environment.apiUrl}/athletes/${id}`;
    return this.http.put(url, payload);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/athletes/${id}`);
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}/athletes/${id}`);
  }

  checkByEmail(email: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/athletes/check-email`, {
      params: { email },
    });
  }

  getForEdit(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}/athletes/${id}/for-edit`);
  }
}

